import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import dashboardService from 'services/dashboard.service';
import IndicatorCard from 'shared/common/indicator-card';
import Loader from 'shared/common/loader';
import PageHeader from 'shared/page-header';
import { dashboardStore } from 'store/DashboardStore';
import { passbookStore } from 'store/PassbookStore';
import { userStore } from 'store/UserStore';
import Layout from '../../wrappers/layout';
import './style.css';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import RedirectToast from 'shared/common/toast/redirectToast';
import { useHistory } from 'react-router-dom';
import Alert from 'shared/common/alert';
import SentGifts from './SentGifts';
import ReceivedGifts from './ReceivedGifts';
import RedeemGiftModal from './RedeemGiftModal';
import giftHttp from './services/gift.service';
import buySellService from 'services/buy-sell.service';
import SupportButton from 'shared/common/supportButton/SupportButton';

interface PropsType {}

const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];

const GiftModule: React.FC<PropsType> = () => {
  const [gramValue, setGramValue] = useState<number>(null);
  const [amountValue, setAmountValue] = useState<number>(null);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [loading, setLoading] = useState<any>(false);
  const [selectedMetalData, setSelectedMetalData] = useState<any>(null);
  const [metalType, setMetalType] = useState<any>('Ag');
  const [metalHoldings, setMetalHoldings] = useState<any>([]);
  const [selectedTab, setSelectedTab] = useState<any>('giftCard');
  const [maxQty, setMaxQty] = useState<any>();
  const [maxAmt, setMaxAmt] = useState<any>();
  const [itemCode, setItemCode] = useState<any>();
  const [quoteResp, setQuoteResp] = useState<any>();
  const [countryCode, setCountryCode] = useState('+91');
  const [giftType, setGiftType] = useState('amt');
  const [isGiftCreated, setIsGiftCreated] = useState(false);
  const [openAccept, setOpenAccept] = useState(false);
  const [Newvalues, setNewvalues] = useState();
  const [NewResetForm, setNewResetForm] = useState();

  const [giftFormData, setGiftFormData] = useState<any>({
    qty: '',
    mobile: '',
    metal: metalType,
    name: '',
    message: '',
  });
  const [open, setOpen] = useState<any>(false);
  const [isSendGift, setIsSendGift] = useState<any>(false);
  // eslint-disable-next-line

  const [
    customerId,
    user,
    selectedAccount,
    customer,
    giftFormDataLS,
    setgiftFormDataLS,
  ] = userStore((state: any) => [
    state.customerId,
    state.user,
    state.selectedAccount,
    state.customer,
    state.giftFormDataLS,
    state.setgiftFormDataLS,
  ]);

  let giftList = new URLSearchParams(location.search).get('giftList');
  let giftListReceived = new URLSearchParams(location.search).get(
    'giftListReceived'
  );

  const history = useHistory();

  const onGramClick = (value) => {
    setGramValue(Number(gramValue) + Number(value));
  };
  const onAmountClick = (value) => {
    setAmountValue(Number(amountValue) + Number(value));
  };

  const metalCards = [
    { name: 'Silver', metalCode: 'Ag', itemCode: 'Ag0003' },
    { name: 'Platinum', metalCode: 'Pt', itemCode: 'Pt00003' },
    { name: 'Palladium', metalCode: 'Pd', itemCode: 'Pd00008' },
    { name: 'Gold', metalCode: 'Au', itemCode: 'Au00005' },
  ];
  const getPassbookSummary = async () => {
    setLoading(true);
    try {
      const res: any = await dashboardService.getPassbookSummary(
        customerId,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setMetalHoldings(res?.data?.data?.metal?.customerHolding);
        // setgiftFormDataLS(res?.data?.data?.metal?.customerHolding)
        if (giftFormDataLS?.metal) {
          setMetalType(giftFormDataLS.metal);
          const ptObject = res?.data?.data?.metal?.customerHolding.find(
            (item) => item.metal === giftFormDataLS.metal
          );
          if (ptObject?.lockQuantity < 0) {
            setMaxQty(ptObject?.quantity + ptObject?.lockQuantity);
          } else {
            setMaxQty(ptObject?.quantity - ptObject?.lockQuantity);
          }
          setMaxAmt(
            ptObject?.value == 0
              ? ptObject?.value
              : ptObject?.value + ptObject?.lockValue
          );
          setItemCode(giftFormDataLS.itemCode);
          setGiftType(giftFormDataLS.giftType);
        } else {
          setMetalType(res?.data?.data?.metal?.customerHolding[0]?.metal);
          if (res?.data?.data?.metal?.customerHolding[0]?.lockQuantity < 0) {
            setMaxQty(
              res?.data?.data?.metal?.customerHolding[0]?.quantity +
                res?.data?.data?.metal?.customerHolding[0]?.lockQuantity
            );
          } else {
            setMaxQty(
              res?.data?.data?.metal?.customerHolding[0]?.quantity -
                res?.data?.data?.metal?.customerHolding[0]?.lockQuantity
            );
          }
          setMaxAmt(
            res?.data?.data?.metal?.customerHolding[0]?.value +
              res?.data?.data?.metal?.customerHolding[0]?.lockValue
          );
          const itCode = metalCards.filter(
            (x: any) =>
              x.metalCode === res?.data?.data?.metal?.customerHolding[0]?.metal
          )[0].itemCode;
          setItemCode(itCode);
        }
        setGiftFormData({
          ...giftFormData,
          metal: res?.data?.data?.metal?.customerHolding[0]?.metal,
        });
        // setMaxQty(res?.data?.data?.metal?.customerHolding[0]?.quantity);

        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  const redirectBuyFunc = async () => {
    const encodedMetal = encodeURI(metalType);
    const url = `/dashboard?gift=${encodedMetal}`;
    history.push(url);
  };

  const validation = Yup.object().shape({
    // installment_amt: Yup.string().nullable().required('Please enter amount or gram'),
    // grams: Yup.string().nullable().required('Please enter gram'),
    qty: Yup.number()
      .min(
        giftType === 'amt' ? 100 : 0.1,
        giftType === 'amt'
          ? 'Amount must be greater than ₹99.'
          : 'Quantity must be greater than 0'
      )
      .required('This field is required.'),

    // qty: Yup.number().required('This field is required.'),
    name: Yup.string().required('This field is required.'),
    mobile: Yup.string()
      .matches(/^[6789]\d{9}$/, 'Invalid mobile number')
      .required('This field is required.'),

    // bank: Yup.string(),
    // duration: Yup.string().required('Please enter frequency'),
    // start_date: Yup.string().required('valid date'),
  });
  const onChangeTab = (tab) => {
    setSelectedTab(tab);
  };

  const addquoute = async (val) => {
    const quotedata = {
      currency: 'INR',
      ebActRef: selectedAccount?.accountId,
      items: [
        {
          itemCode: itemCode,
          otherItems: [],
          requestedType: giftType == 'qty' ? 'PRODUCT_QTY' : 'AMOUNT',
          requestedValue: Number(val?.qty),
          requestedValueAmount: giftType == 'qty' ? null : val?.qty,
          requestedValueQuantity: giftType == 'qty' ? val?.qty : null,
          uom: 'g',
        },
      ],

      type: 'BUYBACK',
    };
    const resp = await buySellService.addQuote(quotedata, user?.userId, '');
    // setPriceBreakdown(resp.data.data);
    setQuoteResp(resp?.data?.data);
    return resp;

    // console.log('quoteres', resp);
  };

  const createGift = async (values, resetForm, setFieldValue) => {
    // console.log('00000', maxQty, maxAmt);
    if (
      (giftType == 'qty' && values?.qty > maxQty) ||
      (giftType == 'amt' && values?.qty > maxAmt)
    ) {
      setgiftFormDataLS({
        ...values,
        metal: metalType,
        maxQty: maxQty,
        maxAmt: maxAmt,
        itemCode: itemCode,
        giftType: giftType,
      });

      setOpen(true);
    } else {
      try {
        setIsSendGift(true);
        const resp1 = await addquoute(values);
        if (resp1?.data.data) {
          if (resp1?.data.data.code == 500) {
            setOpen(true);
            setIsSendGift(false);

            return toast.error(resp1?.data.data.title);
          } else if (resp1?.data?.data?.ebQuoteRef) {
            // console.log('resp1:::', resp1);
            const data = {
              customerId: customerId,
              receiverName: values?.name,
              receiverMobileNo: countryCode + values?.mobile,
              metalCode: metalType,
              metalQuantity: giftType == 'qty' ? values?.qty : null,
              metalAmount: giftType == 'amt' ? values?.qty : null,
              message: values?.message,
              ebQuoteRef: resp1?.data?.data?.ebQuoteRef,
              partnerId: customer?.partner?.id,
            };
            const res = await giftHttp.createGift(data);
            if (res?.status == 200) {
              toast.success('Gift sent successfully');
              setgiftFormDataLS({});
              history.push('/gift?giftList=true');
              // window.location.href = '/gift?giftList=true';
              setGramValue(null);
              setAmountValue(null);
              setIsGiftCreated(!isGiftCreated);
              // resetForm();
              // setGiftFormData({
              //   qty: '',
              //   mobile: '',
              //   metal: metalType,
              //   name: '',
              //   message: '',
              // });
              // setgiftFormDataLS({});
              setGiftType('amt');
              setIsSendGift(false);
            } else {
              setIsSendGift(false);

              toast.error('Something went wrong');
              console.log('errorr');
            }
          }
        }
      } catch (err: any) {
        console.log(typeof err?.data.errors[0].title);

        // toast.error(err?.data.errors[0].title);
        // setOpen(true);
        if (err?.data.errors[0].title === 'Insufficient metal balance') {
          setgiftFormDataLS({
            ...values,
            metal: metalType,
            maxQty: maxQty,
            maxAmt: maxAmt,
            itemCode: itemCode,
            giftType: giftType,
          });
          setOpen(true);
        } else {
          // resetForm();
          setIsSendGift(false);
          setgiftFormDataLS({});
          setGramValue(null);
          setAmountValue(null);
          // setOpen(false);
          setGiftType('amt');
        }
        toast.error(err?.data.errors[0].title, {
          className: 'custom-toast',
        });
      }
    }
  };

  useEffect(() => {
    getPassbookSummary();

    // console.log('90899', giftFormData, maxQty, giftFormDataLS);
  }, [giftFormDataLS]);
  // console.log('itemCode::', itemCode);
  const onSuccess = () => {
    // cancelFunction();

    redirectBuyFunc();
    setOpen(false);
  };

  const onCancel = () => {
    setgiftFormDataLS({});
    setGramValue(null);
    setAmountValue(null);
    setOpen(false);
    setOpenAccept(false);
    setGiftType('amt');
    setIsSendGift(false);
  };

  const sendModalFunc = (values, resetForm, setFieldValue) => {
    setOpenAccept(true);
    setNewvalues(values);
    setNewResetForm(resetForm);

    // setNewValues(values)
  };
  const onSuccessAccept = () => {
    // cancelFunction();

    createGift(Newvalues, NewResetForm, '');
    setOpenAccept(false);
  };

  useEffect(() => {
    if (giftList == 'true') {
      onChangeTab('giftList');
      // setSelectedTab('sippassbook');
    } else if (giftListReceived == 'true') {
      onChangeTab('giftListReceived');
    }
  }, [giftList, giftListReceived, isGiftCreated]);
  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div className='pb'>
          {/*<Toast/>*/}
          {/* <PageHeader
            mainTitle={user.displayName}
            subTitle='Below are your available holdings for gift'
          /> */}
          {/* <Form> */}
          <Tabs
            defaultActiveKey={selectedTab}
            id='uncontrolled-tab-example'
            className='mb-3'
            onSelect={onChangeTab}
          >
            <Tab eventKey='giftCard' title='Gift'>
              <Formik
                initialValues={{
                  qty: giftFormDataLS.qty ? giftFormDataLS.qty : '',
                  amt: giftFormDataLS.amt ? giftFormDataLS.amt : '',
                  mobile: giftFormDataLS.mobile ? giftFormDataLS.mobile : '',
                  name: giftFormDataLS.name ? giftFormDataLS.name : '',
                  message: giftFormDataLS.message ? giftFormDataLS.message : '',
                  metal: giftFormDataLS.metal
                    ? giftFormDataLS.metal
                    : metalType,
                }}
                onSubmit={(
                  values,
                  { setSubmitting, setErrors, resetForm, setFieldValue }
                ) => {
                  setSubmitting(false);
                  // save(values, setErrors);
                  // createGift(values, resetForm, setFieldValue);
                  sendModalFunc(values, resetForm, setFieldValue);
                }}
                validationSchema={validation}
              >
                {({
                  values,
                  isSubmitting,
                  errors,
                  touched,
                  setErrors,
                  setFieldValue,
                  setFieldTouched,
                  resetForm,
                  isValid,
                  dirty,
                }) => (
                  <FormikForm>
                    <Row>
                      <Col
                        md={5}
                        // style={{ border: '1px solid black' }}
                      >
                        <Form.Label className='gift-label'>
                          Select Metal
                        </Form.Label>
                        <Row className='justify-content-between'>
                          {metalHoldings.map((met, index) => (
                            <Col xs={6} key={index}>
                              <Card
                                className={`gift-metal-card mb-3 ${
                                  metalType == met?.metal
                                    ? 'gift-metal-card-bg-checked'
                                    : 'gift-metal-card-bg'
                                }`}
                              >
                                <Card.Body>
                                  <div className='gift-mobile-card'>
                                    <Form.Check
                                      type='radio'
                                      name='gift-radio'
                                      id={`${
                                        metalCards.filter(
                                          (x: any) => x.metalCode === met?.metal
                                        )[0].itemCode
                                      }`}
                                      className='gift-radio'
                                      value={met?.metal}
                                      onChange={(e) => {
                                        setMetalType(e.target.value);
                                        setGiftFormData({
                                          ...giftFormData,
                                          metal: e.target.value,
                                        });
                                        if (met.lockQuantity < 0) {
                                          setMaxQty(
                                            met.quantity + met.lockQuantity
                                          );
                                        } else {
                                          setMaxQty(
                                            met.quantity - met.lockQuantity
                                          );
                                        }
                                        setMaxAmt(
                                          met.value == 0
                                            ? met.value
                                            : met.value + met.lockValue
                                        );

                                        setItemCode(e.target.id);
                                      }}
                                      // defaultChecked={index === 0}
                                      checked={met?.metal === metalType}
                                    />
                                    <div
                                      className={`${
                                        metalType == met?.metal &&
                                        'gift-metal-text-clr'
                                      }`}
                                    >
                                      <Card.Title
                                        className={`gift-metal-text  `}
                                      >
                                        {metalCards.filter(
                                          (x: any) => x.metalCode === met?.metal
                                        ).length > 0
                                          ? metalCards.filter(
                                              (x: any) =>
                                                x.metalCode === met?.metal
                                            )[0].name
                                          : ''}
                                      </Card.Title>
                                      <Card.Text className='gift-metal-price'>
                                        {(met.quantity > 0
                                          ? met.lockQuantity < 0
                                            ? met.quantity + met.lockQuantity >
                                              0
                                              ? met.quantity + met.lockQuantity
                                              : 0
                                            : met.quantity - met.lockQuantity >
                                              0
                                            ? met.quantity - met.lockQuantity
                                            : 0
                                          : 0
                                        ).toFixed(4)}{' '}
                                        g
                                      </Card.Text>
                                      {/* <Card.Text className='gift-metal-price'>
                                      ₹{(met.value > 0
                                          ? met.value + met.lockValue
                                          : met.value
                                        ).toFixed(4)}{' '}
                                      </Card.Text> */}
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          ))}
                        </Row>
                      </Col>
                      <Col
                        md={7}
                        // style={{ border: '1px solid red' }}
                      >
                        {/* <Row>
                <Col
                  md={6}
                  style={{
                    border: '1px solid black',
                    height: '400px',
                    width: '100%',
                  }}
                > */}
                        <div
                          className='gift-form-container '
                          style={{
                            // border: '1px solid red',
                            height: '300px',
                            width: '100%',
                          }}
                        >
                          {/* <Form> */}
                          <Form.Label className='gift-label'>
                            Select Gift Type
                          </Form.Label>
                          <Row>
                            <Col xs={6}>
                              <Card
                                className={`gift-type-card mb-3 ${
                                  giftType == 'amt'
                                    ? 'gift-metal-card-bg-checked'
                                    : 'gift-metal-card-bg'
                                }`}
                              >
                                <Card.Body>
                                  <div className='d-flex'>
                                    <Form.Check
                                      type='radio'
                                      name='type-radio'
                                      className=' gift-type-radio'
                                      value={'amt'}
                                      // defaultChecked={index === 0}
                                      checked={giftType == 'amt'}
                                      onChange={(e) => {
                                        setGiftType(e.target.value);
                                        setGramValue(null);
                                        setFieldValue('qty', '');
                                      }}
                                    />
                                    <Card.Title
                                      className={`gift-type-text ${
                                        giftType == 'amt' &&
                                        'gift-metal-text-clr'
                                      }`}
                                    >
                                      Amount
                                    </Card.Title>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col xs={6}>
                              <Card
                                className={`gift-type-card  ${
                                  giftType == 'qty'
                                    ? 'gift-metal-card-bg-checked'
                                    : 'gift-metal-card-bg'
                                }`}
                              >
                                <Card.Body>
                                  <div className='d-flex '>
                                    <Form.Check
                                      type='radio'
                                      name='type-radio'
                                      className='gift-type-radio'
                                      value={'qty'}
                                      // defaultChecked={index === 0}
                                      checked={giftType == 'qty'}
                                      onChange={(e) => {
                                        setGiftType(e.target.value);
                                        setAmountValue(null);
                                        setFieldValue('qty', '');
                                      }}
                                    />
                                    <Card.Title
                                      className={`gift-type-text ${
                                        giftType == 'qty' &&
                                        'gift-metal-text-clr'
                                      }`}
                                    >
                                      Quantity
                                    </Card.Title>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              {giftType == 'qty' ? (
                                <>
                                  <Form.Label className='gift-label'>
                                    Quantity{' '}
                                    <span className='gift-label-bracket'>
                                      (in grams)
                                    </span>
                                  </Form.Label>
                                  <Field
                                    type='number'
                                    className='gift-input '
                                    defaultValue={
                                      Number(gramValue)
                                        ? Number(gramValue)
                                        : null
                                    }
                                    placeholder='Enter here'
                                    name='qty'
                                    onBlur={(e) => {
                                      setFieldTouched('qty');
                                    }}
                                    onChange={(e: any) => {
                                      const inputValue = e.target.value;
                                      const parts = inputValue.split('.');
                                      if (parts[1] && parts[1].length > 4) {
                                        e.preventDefault();
                                      } else {
                                        setFieldValue('qty', inputValue);
                                        setGramValue(Number(inputValue));
                                        setGiftFormData({
                                          ...giftFormData,
                                          qty: Number(inputValue),
                                        });
                                      }
                                    }}
                                  />
                                  <div className='error text-danger ml-2'>
                                    <ErrorMessage name='qty'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <Form.Label className='gift-label'>
                                    Amount{' '}
                                    <span className='gift-label-bracket'>
                                      (in rupees)
                                    </span>
                                  </Form.Label>
                                  <Field
                                    type='number'
                                    className='gift-input '
                                    defaultValue={
                                      Number(amountValue)
                                        ? Number(amountValue)
                                        : null
                                    }
                                    placeholder='Enter here'
                                    name='qty'
                                    onBlur={(e) => {
                                      setFieldTouched('qty');
                                    }}
                                    onChange={(e: any) => {
                                      const inputValue = e.target.value;
                                      const parts = inputValue.split('.');
                                      if (parts[1] && parts[1].length > 2) {
                                        e.preventDefault();
                                      } else {
                                        setFieldValue('qty', inputValue);
                                        setAmountValue(Number(inputValue));
                                        setGiftFormData({
                                          ...giftFormData,
                                          amt: Number(inputValue),
                                        });
                                      }
                                    }}
                                  />
                                  <div className='error text-danger ml-2'>
                                    <ErrorMessage name='qty'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </>
                              )}
                              {/* <Field
                                type='number'
                                className='gift-input '
                                defaultValue={
                                  Number(gramValue) ? Number(gramValue) : null
                                }
                                placeholder='Enter here'
                                name='qty'
                                onBlur={(e) => {
                                  setFieldTouched('qty');
                                }}
                                onChange={(e: any) => {
                                  const inputValue = e.target.value;
                                  const parts = inputValue.split('.');
                                  if (parts[1] && parts[1].length > 4) {
                                    e.preventDefault();
                                  } else {
                                    setFieldValue('qty', inputValue);
                                    setGramValue(Number(inputValue));
                                    setGiftFormData({
                                      ...giftFormData,
                                      qty: Number(inputValue),
                                    });
                                  }
                                }}
                              /> */}
                              {/* <div className='error text-danger ml-2'>
                                <ErrorMessage name='qty'>
                                  {(msg) => (
                                    <span className='error'>{msg}</span>
                                  )}
                                </ErrorMessage>
                              </div> */}
                            </Col>
                            <Col md={6}>
                              <Form.Label></Form.Label>
                              {/* <Form.Control type='text' className='gift-input' /> */}
                              {giftType == 'qty' ? (
                                <div className='d-flex justify-content-around gift-gram-btn-none'>
                                  {[1.0, 5.0, 10.0].map((gram) => (
                                    <Button
                                      variant='outline-warning'
                                      size='sm'
                                      onClick={(e) => {
                                        onGramClick(Number(gram));
                                        setFieldValue('qty', gramValue + gram);
                                        setGiftFormData({
                                          ...giftFormData,
                                          qty: Number(gramValue) + Number(gram),
                                        });
                                      }}
                                      className='gift-gram-btn m-2'
                                    >
                                      <span className='gift-gram-text'>
                                        {' '}
                                        + {gram} g
                                      </span>
                                    </Button>
                                  ))}
                                </div>
                              ) : (
                                <div className='d-flex justify-content-around gift-gram-btn-none'>
                                  {[100, 500, 1000].map((amount) => (
                                    <Button
                                      variant='outline-warning'
                                      size='sm'
                                      onClick={(e) => {
                                        onAmountClick(Number(amount));
                                        setFieldValue(
                                          'qty',
                                          amountValue + amount
                                        );

                                        setGiftFormData({
                                          ...giftFormData,
                                          qty:
                                            Number(amountValue) +
                                            Number(amount),
                                        });
                                      }}
                                      className='gift-gram-btn m-2'
                                    >
                                      <span className='gift-gram-text'>
                                        + ₹{amount}
                                      </span>
                                    </Button>
                                  ))}
                                </div>
                              )}
                            </Col>
                          </Row>
                          <Row className='mt-3'>
                            <Col md={6} className='mb-3'>
                              <Form.Label className='gift-label '>
                                Recipient Name
                              </Form.Label>
                              <Form.Control
                                type='text'
                                className='gift-input  mb-1'
                                placeholder='Enter recipient name'
                                name='name'
                                maxLength={35}
                                defaultValue={
                                  giftFormDataLS.name
                                    ? giftFormDataLS?.name
                                    : ''
                                }
                                onChange={(e) => {
                                  setFieldValue('name', e.target.value);
                                  setGiftFormData({
                                    ...giftFormData,
                                    name: e.target.value,
                                  });
                                }}
                              />
                              <div className='error text-danger ml-2'>
                                <ErrorMessage name='name'>
                                  {(msg) => (
                                    <span className='error'>{msg}</span>
                                  )}
                                </ErrorMessage>
                              </div>
                            </Col>
                            <Col md={6} className='mb-3'>
                              <Form.Label className='gift-label'>
                                Recipient Mobile
                              </Form.Label>

                              <div className='input-group mb-1'>
                                <div className='input-group-prepend'>
                                  <select
                                    className='gift-input p-2 form-control' // Added 'form-control' class here
                                    onChange={(event) =>
                                      setCountryCode(event.target.value)
                                    }
                                    value={countryCode}
                                  >
                                    <option value={'+91'}>+91</option>
                                  </select>
                                </div>

                                <Field
                                  type='number'
                                  name='mobile'
                                  className='gift-input country-code-gift form-control'
                                  placeholder='Enter recipient mobile no'
                                  onBlur={(e) => {
                                    setFieldTouched('mobile');
                                  }}
                                  onChange={(e: any) => {
                                    setFieldValue('mobile', e.target.value);
                                    setGiftFormData({
                                      ...giftFormData,
                                      mobile: e.target.value,
                                    });
                                  }}
                                />
                              </div>

                              <div className='error text-danger ml-2'>
                                <ErrorMessage name='mobile'>
                                  {(msg) => (
                                    <span className='error'>{msg}</span>
                                  )}
                                </ErrorMessage>
                              </div>
                            </Col>
                          </Row>
                          <Row className=''>
                            <Col>
                              <Form.Label className='gift-label'>
                                Message
                              </Form.Label>
                              <Form.Control
                                as='textarea'
                                placeholder='Enter message'
                                name='message'
                                className='gift-textarea'
                                defaultValue={
                                  giftFormDataLS.message
                                    ? giftFormDataLS?.message
                                    : ''
                                }
                                onChange={(e: any) => {
                                  setFieldValue('message', e.target.value);
                                  setGiftFormData({
                                    ...giftFormData,
                                    message: e.target.value,
                                  });
                                }}
                              />
                            </Col>
                          </Row>
                          <div className='d-flex justify-content-end'>
                            <Button
                              className='mt-3 gift-send-btn '
                              type='submit'
                              disabled={isSendGift}
                            >
                              Send Gift
                            </Button>
                          </div>
                          {/* </Form> */}
                        </div>
                        {/* <Form>
                    <div className='my-1 col col-sm-12 '>
                      <div className='input-gift-container'>
                        <Form.Control
                          type='text'
                          placeholder='Quantity'
                          style={{
                            backgroundColor: '#EAE6DD',
                            height: '50%',
                            width: '100%',
                          }}
                        />
                      </div>
                    </div>
                  </Form> */}
                        {/* </Col>
              </Row> */}
                      </Col>
                    </Row>
                  </FormikForm>
                )}
              </Formik>
            </Tab>
            <Tab eventKey='giftList' title='Sent Gifts '>
              <SentGifts />
            </Tab>
            <Tab eventKey='giftListReceived' title='Received Gifts '>
              <ReceivedGifts getPassbookSummary={getPassbookSummary} />
            </Tab>
          </Tabs>

          {/* </Form> */}
        </div>
      )}
      {/* {customer.customerCategory === 'UNREGISTERED' &&
      customer?.nomineeDetails?.length < 1 && <NomineeModal />} */}
      {/* <Alert
        open={open}
        message='Insufficient metal balance. Proceed to buy.'
        onSuccess={onSuccess}
        onCancel={onCancel}
        successBtnText='Proceed'
      /> */}
      <RedeemGiftModal
        redirectFunc={redirectBuyFunc}
        showModal={open}
        closeModal={setOpen}
        proceed={onSuccess}
        cancel={onCancel}
        text={'Insufficient metal balance. Proceed to buy.'}
        okButton={'Proceed'}
        cancelButton={'Cancel'}
      />
      <RedeemGiftModal
        showModal={openAccept}
        closeModal={setOpenAccept}
        proceed={onSuccessAccept}
        cancel={onCancel}
        text={`Are you sure you want to send gift to this number ${
          (giftFormDataLS?.mobile) ? giftFormDataLS?.mobile : giftFormData?.mobile
        }?`}
        okButton={'Send'}
        cancelButton={'Cancel'}
      />
    </Layout>
  );
};

export default GiftModule;
